var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('form-field-text');
export var FormFieldTextDefaultProps = {
  multiLine: false,
  type: 'text',
  value: '',
  newPlaceholder: ''
};
// -------- Styles -------->
var InputStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    border: 1px solid ", ";\n    font-weight: 400;\n    background-color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    color: ", ";\n    transition: border-color 0.25s, outline-color 0.25s;\n    border-radius: ", ";\n    box-shadow: 0px 2px 1px inset rgba(0,0,0, 0.02);\n    outline: 3.5px solid transparent;\n    -webkit-appearance: none;\n\n    &:disabled {\n      opacity: 0.4;\n    }\n\n    &[type=number]::-webkit-inner-spin-button, \n    &[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none; \n      margin: 0; \n    }\n\n    &:focus {\n      outline-color: ", ";\n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    border: 1px solid ", ";\n    font-weight: 400;\n    background-color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    color: ", ";\n    transition: border-color 0.25s, outline-color 0.25s;\n    border-radius: ", ";\n    box-shadow: 0px 2px 1px inset rgba(0,0,0, 0.02);\n    outline: 3.5px solid transparent;\n    -webkit-appearance: none;\n\n    &:disabled {\n      opacity: 0.4;\n    }\n\n    &[type=number]::-webkit-inner-spin-button, \n    &[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none; \n      margin: 0; \n    }\n\n    &:focus {\n      outline-color: ", ";\n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n  "])), theme.COLOR('line-mid'), theme.COLOR('canvas'), theme.FONT('app'), theme.FONT_SIZE(16), theme.UNIT(3), theme.UNIT(3), theme.UNIT(3.1), theme.COLOR('strong'), theme.UNIT(2), theme.COLOR('app-chrome'), theme.COLOR('text-very-subtle'), function (props) {
    return props._maxWidth && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "])), props._maxWidth);
  }, function (props) {
    return props.variant === 'gradient' && !props.valid && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-color: ", ";\n      border-top-color: ", ";\n    "], ["\n      border-color: ", ";\n      border-top-color: ", ";\n    "])), theme.COLOR('line-mid'), theme.COLOR('error'));
  }),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(14))
});
var TextAreaStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    height: 200px;\n    width: 100%;\n    box-sizing: border-box;\n    resize: vertical;\n  "], ["\n    ", ";\n    height: 200px;\n    width: 100%;\n    box-sizing: border-box;\n    resize: vertical;\n  "])), InputStyles)
});
// -------- Components -------->
var My = {
  Input: styled.input(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  TextArea: styled.textarea(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), TextAreaStyles)
};
export var FormFieldText = function (props) {
  var className = props.className,
    autoFocus = props.autoFocus,
    value = props.value,
    type = props.type,
    newPlaceholder = props.newPlaceholder,
    disabled = props.disabled,
    autoComplete = props.autoComplete;
  var handleBlur = props.onBlur && function (event) {
    event.preventDefault();
    event.stopPropagation();
    props.onBlur({
      event: event,
      value: event.target.value
    });
  };
  var handleChange = props.onChange && function (event) {
    event.preventDefault();
    event.stopPropagation();
    props.onChange({
      event: event,
      value: event.target.value
    });
  };
  var Control = props.multiLine ? My.TextArea : My.Input;
  return /* @ts-ignore */(
    React.createElement(Control, {
      autoFocus: autoFocus,
      className: cls.name(className),
      name: props.name,
      placeholder: newPlaceholder,
      type: type,
      disabled: disabled,
      value: value,
      autoComplete: autoComplete,
      onBlur: handleBlur,
      onChange: handleChange
    })
  );
};
export var FormFieldTextArea = function (props) {
  return React.createElement(FormFieldText, __assign({}, props, {
    multiLine: true
  }));
};
export var FormFieldPassword = function (props) {
  return React.createElement(FormFieldText, __assign({}, props, {
    multiLine: false,
    type: "password"
  }));
};
FormFieldTextArea.cls = cls;
FormFieldTextArea.defaultProps = FormFieldTextDefaultProps;
FormFieldPassword.cls = cls;
FormFieldPassword.defaultProps = FormFieldTextDefaultProps;
FormFieldText.cls = cls;
FormFieldText.defaultProps = FormFieldTextDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;